import { reviews, categories } from '@/mocks/gua';

export default function ReviewSection() {
  return (
    <section className="container-x py-12 md:py-16">
      <div id="review" className="scroll-mt-24 flex flex-col gap-1.5">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">全经过复盘</span>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">深度长文 · 把始末讲清楚</h2>
        <p className="mt-1 max-w-2xl text-sm text-foreground-700">
          不只是罗列时间点，我们更想讲清每个转折背后的逻辑，适合想深入了解的你。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
        {reviews.map((r) => (
          <article
            key={r.id}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-accent-300"
          >
            <a href="#about" className="block overflow-hidden">
              <img
                src={r.cover}
                alt={r.title}
                className="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
              />
            </a>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex items-center justify-between text-xs text-secondary-600">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-900">
                  <i
                    className={categories.find((c) => c.key === r.category)?.icon}
                    aria-hidden="true"
                  ></i>
                  {categories.find((c) => c.key === r.category)?.name}
                </span>
                <span>{r.date}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
                <a href="#about" className="transition-colors group-hover:text-primary-700">
                  {r.title}
                </a>
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{r.summary}</p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {r.chapters.map((c) => (
                  <span key={c} className="rounded-full bg-background-50 px-2 py-0.5 text-[11px] text-secondary-700 ring-1 ring-background-200">
                    {c}
                  </span>
                ))}
              </div>

              <div className="mt-auto flex items-center justify-between pt-5">
                <span className="text-xs text-secondary-600">
                  <i className="ri-time-line mr-1" aria-hidden="true"></i>
                  {r.read}
                </span>
                <a
                  href="#about"
                  className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
                >
                  开始阅读
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}